import { Link } from "react-router-dom";

function Header ({menuOn, setMenuOn}) {
  const onMenuClick = () => {
    setMenuOn(curMenuActive => !curMenuActive);    
  }
  
  return (
    <div className={`part header ${menuOn && 'menuOn'}`} >
      <section className="sector">
        <div className = "container container-w-full">
          <div className="container-in">
            
            <div className="logo">
              <Link className="logo-link" to="/">
                <svg xmlns="http://www.w3.org/2000/svg" id="svg-header-f9-logo" version="1.1" viewBox="0 0 1000 1000">
                  <mask id="header-logo-mask-g">
                    <use className="logo-mask logo-mask1" xlinkHref="#b3-u-1-mask" />
                    <use className="logo-mask logo-mask2" xlinkHref="#b3-u-2-mask" />
                  </mask>
                  <g className="logo-paths">
                    <use className="logo-path logo-path-a logo-path-a1" xlinkHref="#b3-u-2-path" />
                    <use className="logo-path logo-path-a logo-path-a2" xlinkHref="#b3-u-1-path" />
                    <use className="logo-path logo-path-b logo-path-b1" xlinkHref="#b3-u-2-path" mask="url(#header-logo-mask-g)" />
                    <use className="logo-path logo-path-b logo-path-b2" xlinkHref="#b3-u-1-path" mask="url(#header-logo-mask-g)" />
                  </g>
                </svg>
              </Link>
            </div>
            <div className="name-menu" onClick={onMenuClick}>
              <div className="name-menu__name"><span>F</span><span>A</span><span>C</span><span>T</span><span>O</span><span>R</span><span>Y</span><span>9</span>&nbsp;</div>
              <div className="name-menu__menu">
                <span className="menu-bar top"></span>
                <span className="menu-bar middle"></span>
                <span className="menu-bar bottom"></span>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default Header;